/**
 * StaffCortexAdmin — IT-SCE Intern: Cortex-Verwaltung (Uebersicht + Permissions).
 *
 * TQ #9698 (Staff-Migration Teil E, Bundle #9523). Kein bestehender
 * Sidebar-Link (anders als Teil B/D) — eigene neue Route + Sidebar-Eintrag.
 *
 * ROUTING-ENTSCHEIDUNG (Sub-Task-Scope): Quelle
 * customer-portal/src/pages/staff/StaffHubPages.tsx gruppiert Cortex-
 * Uebersicht + Permissions im SELBEN "Plattform"-Hub wie System-Health
 * (Teil D, #9697, parallel in Arbeit). Um KEINEN Datei-/Route-Konflikt mit
 * dem parallel laufenden Teil D zu riskieren, baut dieser Task Cortex-Admin
 * als EIGENE Route /staff/cortex (2 Tabs: Uebersicht/Permissions) statt in
 * #9697s Health-Page hineinzuschreiben. Pfad-Namen (/staff/cortex,
 * /staff/permissions-Konzept als Tab statt Sub-Route) folgen bewusst der
 * Original-Hub-Struktur, damit eine spaetere Konsolidierung (Health+Cortex
 * in einem "Plattform"-Hub, falls gewuenscht) ohne Rename moeglich ist —
 * das ist ein Folge-Task, kein Teil dieses Sub-Tasks.
 */

import { useState } from 'react'
import StaffCortex from './StaffCortex'
import StaffCortexPermissions from './StaffCortexPermissions'

type Tab = 'usage' | 'permissions'

const TABS: { key: Tab; label: string; icon: string }[] = [
  { key: 'usage', label: 'Cortex-Übersicht', icon: '🧠' },
  { key: 'permissions', label: 'Permissions', icon: '🔒' },
]

export default function StaffCortexAdmin() {
  const [tab, setTab] = useState<Tab>('usage')

  return (
    <div>
      <div
        role="tablist"
        aria-label="Cortex-Verwaltung"
        style={{
          display: 'flex', gap: 4, padding: '0 1.5rem', marginTop: '1.5rem',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        {TABS.map((t) => (
          <button
            key={t.key}
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: '0.75rem 1rem',
              border: 'none',
              borderBottom: tab === t.key ? '2px solid #2563eb' : '2px solid transparent',
              background: 'transparent',
              color: tab === t.key ? '#2563eb' : '#374151',
              fontWeight: tab === t.key ? 600 : 500,
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {tab === 'usage' && <StaffCortex />}
      {tab === 'permissions' && <StaffCortexPermissions />}
    </div>
  )
}
